import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getProductsAndServicesQueryOptions } from '@/_pages/products-and-services/api-service';

export const Route = createFileRoute('/_private/products-and-services/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getProductsAndServicesQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={8} />,
});
